var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DefaultLayout',[_c('ContentHeader',{attrs:{"title":"Create new Order"}}),_vm._v(" Order Add content ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }